export const GOOGLE_PAY_GATEWAY = 'rapyd';

export const DEFAULT_GOOGLE_PAY_VERSION = {
  apiVersion: 2,
  apiVersionMinor: 0
};

export const GOOGLE_PAY_ALLOWED_NETWORKS = [
  'amex',
  'discover',
  'interac',
  'jcb',
  'mastercard',
  'visa'
];

export const GOOGLE_PAY_ALLOWED_NETWORKS_IN_BRAZIL = [
  ...GOOGLE_PAY_ALLOWED_NETWORKS,
  'electron',
  'elo',
  'elo_debit',
  'maestro'
];

export const GOOGLE_PAY_PAYMENT_METHOD_TYPE = {
  CARD: 'CARD',
  PAYPAL: 'PAYPAL'
};

export const GOOGLE_PAY_CARD_AUTH_METHOD = {
  PAN_ONLY: 'PAN_ONLY',
  CRYPTOGRAM_3DS: 'CRYPTOGRAM_3DS'
};

export const GOOGLE_PAY_PAYMENT_METHOD_TOKENIZATION_TYPE = {
  PAYMENT_GATEWAY: 'PAYMENT_GATEWAY',
  DIRECT: 'DIRECT'
};

export const GOOGLE_PAY_TOTAL_PRICE_STATUS = {
  NOT_CURRENTLY_KNOWN: 'NOT_CURRENTLY_KNOWN',
  ESTIMATED: 'ESTIMATED',
  FINAL: 'FINAL'
};

export const GOOGLE_PAY_TRANSACTION_RESULT = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

export const GOOGLE_PAY_ERROR_REASON = {
  SHIPPING_ADDRESS_INVALID: 'SHIPPING_ADDRESS_INVALID',
  SHIPPING_ADDRESS_UNSERVICEABLE: 'SHIPPING_ADDRESS_UNSERVICEABLE',
  SHIPPING_OPTION_INVALID: 'SHIPPING_OPTION_INVALID',
  OFFER_INVALID: 'OFFER_INVALID',
  PAYMENT_DATA_INVALID: 'PAYMENT_DATA_INVALID',
  OTHER_ERROR: 'OTHER_ERROR'
};

export const GOOGLE_PAY_CALLBACK_INTENT = {
  OFFER: 'OFFER',
  SHIPPING_ADDRESS: 'SHIPPING_ADDRESS',
  SHIPPING_OPTION: 'SHIPPING_OPTION',
  PAYMENT_AUTHORIZATION: 'PAYMENT_AUTHORIZATION',
  PAYMENT_METHOD: 'PAYMENT_METHOD'
};

export const GOOGLE_PAY_ERROR_MESSAGE_SHEET =
  'Sorry, something went wrong. Please try a different payment method now or close this window and try Google Pay again later. Alternatively, you can close this window and use another payment method.';
